import React from 'react';
import AddCarrierHeader from '../AddCarrierHeader.component';
import Data from '../../data';
import UI from '../../ui';
import Utils from '../../utils';
import eulaSdc from '../../../assets/pdfs/eula-sdc.pdf';
import eulaEndicia from '../../../assets/pdfs/eula-endicia.pdf';

const { Carrier } = Data;
const { Section, SectionBody, Footer } = UI;
const { Session } = Utils;

const FedExEulaAgreement = ({ completionCallback, onAcceptEula, enterpriseLocations }) => {
	const onAcceptButtonClick = () => {
		onAcceptEula(true);
	};

	const onCancelButtonClick = () => {
		completionCallback(false);
	};

	const renderPdf = () => {
		const { brandName } = Session.getBrand();

		if (brandName === 'Stamps.com') {
			return (
				<iframe className="fedex-eula-iframe" title="Stamps.com FedEx EULA" src={eulaSdc} />
			);
		} else if (brandName === 'Endicia') {
			return (
				<iframe
					className="fedex-eula-iframe"
					title="Endicia FedEx EULA"
					src={eulaEndicia}
				/>
			);
		}
	};

	return (
		<div className="common-carrier-fedex-eula">
			<Section>
				<AddCarrierHeader
					title="EULA"
					carrier={Carrier.FedEx}
					subtitle="To start shipping with FedEx, you must first agree to the FedEx End-User License Agreement:"
					dataqa="EULA"
				/>
				<SectionBody dataqa="fedex-eula-body-wrapper">{renderPdf()}</SectionBody>
				<Footer
					primary={{
						label: 'I Agree',
						onClick: onAcceptButtonClick,
						dataqa: 'fedex-eula-primary-btn',
					}}
					secondary={{
						label: enterpriseLocations ? 'Start Over' : 'Cancel',
						onClick: onCancelButtonClick,
						dataqa: 'fedex-eula-secondary-btn',
					}}
				>
					<p data-qa="fedex-eula-legal-copy" {...{ dataqa: 'fedex-eula-legal-copy' }}>
						FedEx service marks are owned by Federal Express Corporation and used by
						permission.
					</p>
				</Footer>
			</Section>
		</div>
	);
};

export default FedExEulaAgreement;
